import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class MatterTypeService {
  /**
   * URL for matter types controller
   * @type {String}
   */
  private matterTypesURL = 'matter_types';

  /**
   * Constructor
   * @param {HttpClientService} private httpClient Service for making HTTP requests with different methods
   */
  constructor(private httpClient: HttpClientService) {}

  /**
   * Clone matter type from intranet
   * @param {[type]}        data Params for request
   * @return {Promise<any>}      Server response with request result
   */
  cloneFromIntranet(data: any): Promise<any> {
    data['clone_from'] = true;
    return this.httpClient.post(this.matterTypesURL + '.json', data).catch(function () {});
  }

  /**
   * Clone matter types to intranet
   * @param {[type]}        data Params for request
   * @return {Promise<any>}      Server response with request result
   */
  cloneToIntranet(data: any): Promise<any> {
    data['clone_to'] = true;
    return this.httpClient.post(this.matterTypesURL + '.json', data).catch(function () {});
  }

  /**
   * Create matter type
   * @param  {any}          data Params with matter type to create
   * @return {Promise<any>}      Server response with request result
   */
  createMatterType(data: any): Promise<any> {
    return this.httpClient.post(this.matterTypesURL + '.json', data).catch(function () {});
  }

  /**
   * Delete matter type
   * @param  {[type]}       matterTypeId Id of matter type to delete
   * @return {Promise<any>}              Server response with request result
   */
  deleteMatterType(matterTypeId: number): Promise<any> {
    return this.httpClient.delete(this.matterTypesURL + '/' + matterTypeId + '.json').catch(function () {});
  }

  /**
   * Edit matter type
   * @param  {[type]}       matterTypeId Id of matter type
   * @return {Promise<any>}              Server response with matter type
   */
  editMatterType(matterTypeId: number): Promise<any> {
    return this.httpClient.get(this.matterTypesURL + '/' + matterTypeId + '/edit.json').catch(function () {});
  }

  /**
   * Clone options for cloning matter types
   * @return {Promise<any>} Server response with clone options
   */
  getCloneOptions(): Promise<any> {
    return this.httpClient
      .get(this.matterTypesURL + '.json', {
        get_clone_options: true,
      })
      .catch(function () {});
  }

  /**
   * Get form options for matter type form
   * @return {Promise<any>} Server response with form options
   */
  getFormOptions(): Promise<any> {
    return this.httpClient
      .get(this.matterTypesURL + '.json', {
        get_form_options: true,
      })
      .catch(function () {});
  }

  /**
   * Get matter types for intranet
   * @param  {[type]}       data Search params
   * @return {Promise<any>}      Server response with matter types
   */
  getMatterTypes(data: any): Promise<any> {
    return this.httpClient.get(this.matterTypesURL + '.json', data).catch(function () {});
  }

  /**
   * Update matter type
   * @param  {[type]}       matterTypeId Id of matter type
   * @param  {any}          data         Matter type to update
   * @return {Promise<any>}              Server response with request result
   */
  updateMatterType(matterTypeId: number, data: any): Promise<any> {
    return this.httpClient.put(this.matterTypesURL + '/' + matterTypeId + '.json', data).catch(function () {});
  }
}
